/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../connect/v2/common/money';
import '../banking/withholding_config_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "invest": {
        "nested": {
          "AccountType": {
            "values": {
              "DO_NOT_USE": 0,
              "BTC_TREASURY": 1
            }
          },
          "InvestingActivity": {
            "fields": {
              "type": {
                "type": "squareup.invest.InvestingActivity.ActivityType",
                "id": 1,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "fromAmount": {
                "type": "squareup.connect.v2.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "toAmount": {
                "type": "squareup.connect.v2.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "feeAmount": {
                "type": "squareup.connect.v2.common.Money",
                "id": 5,
                "rule": "optional"
              },
              "status": {
                "type": "squareup.invest.InvestingActivity.Status",
                "id": 6,
                "rule": "optional"
              },
              "orderToken": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "investmentAccountId": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "purchasePrice": {
                "type": "squareup.connect.v2.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "idempotenceToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              }
            },
            "nested": {
              "ActivityType": {
                "values": {
                  "DO_NOT_USE": 0,
                  "AUTOMATED_BITCOIN_SAVINGS_BUY_CASH_APP": 1
                }
              },
              "Status": {
                "values": {
                  "ACTIVITY_STATUS_DO_NOT_USE": 0,
                  "PENDING": 1,
                  "SUCCEEDED": 2,
                  "FAILED": 3
                }
              }
            }
          },
          "InvestmentAccountMetadata": {
            "fields": {
              "accountType": {
                "type": "squareup.invest.AccountType",
                "id": 1,
                "rule": "optional"
              },
              "accountStatus": {
                "type": "squareup.invest.InvestmentAccountMetadata.AccountStatus",
                "id": 2,
                "rule": "optional"
              },
              "pendingBalance": {
                "type": "squareup.connect.v2.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "currentBalance": {
                "type": "squareup.connect.v2.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "cashappIdentifier": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 6,
                "rule": "optional"
              },
              "accountId": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "marketValue": {
                "type": "squareup.connect.v2.common.Money",
                "id": 8,
                "rule": "optional"
              },
              "customerToken": {
                "type": "string",
                "id": 9,
                "rule": "optional"
              },
              "createdAt": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "accountRelationship": {
                "type": "squareup.invest.InvestmentAccountMetadata.AccountRelationship",
                "id": 11,
                "rule": "optional"
              },
              "grantId": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              }
            },
            "nested": {
              "AccountStatus": {
                "values": {
                  "DO_NOT_USE": 0,
                  "ACTIVE": 1,
                  "DISABLED": 2,
                  "PENDING_WITHHOLDING": 3,
                  "DEACTIVATED": 4,
                  "PENDING_MANUAL_REVIEW": 5,
                  "REJECTED_MANUAL_REVIEW": 6
                }
              },
              "AccountRelationship": {
                "values": {
                  "ACCOUNT_RELATIONSHIP_DO_NOT_USE": 0,
                  "OWNER": 1,
                  "LLC_MEMBER": 2,
                  "BUSINESS_PARTNER": 3,
                  "PRINCIPAL_OFFICER": 4,
                  "PARTNER_SPOUSE": 5,
                  "EMPLOYEE_MANAGER": 6,
                  "OTHER": 7
                }
              }
            }
          },
          "InvestWithholdingMetadata": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "withholdingConfig": {
                "type": "squareup.banking.WithholdingConfig",
                "id": 2,
                "rule": "optional"
              },
              "accountType": {
                "type": "squareup.invest.AccountType",
                "id": 3,
                "rule": "optional"
              },
              "banklinClearingAccountSvt": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "targetCustomerToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "WithholdingUpdateEvent": {
            "fields": {
              "merchantToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "withholdingConfigId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "enabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              },
              "withholdingBps": {
                "type": "uint32",
                "id": 4,
                "rule": "optional"
              },
              "targetCustomerToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "banklinClearingAccountSvt": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.invest?.nested?.AccountType && !$root.nested?.squareup?.nested?.invest?.nested?.InvestingActivity && !$root.nested?.squareup?.nested?.invest?.nested?.InvestingActivity?.nested?.ActivityType && !$root.nested?.squareup?.nested?.invest?.nested?.InvestingActivity?.nested?.Status && !$root.nested?.squareup?.nested?.invest?.nested?.InvestmentAccountMetadata && !$root.nested?.squareup?.nested?.invest?.nested?.InvestmentAccountMetadata?.nested?.AccountStatus && !$root.nested?.squareup?.nested?.invest?.nested?.InvestmentAccountMetadata?.nested?.AccountRelationship && !$root.nested?.squareup?.nested?.invest?.nested?.InvestWithholdingMetadata && !$root.nested?.squareup?.nested?.invest?.nested?.WithholdingUpdateEvent) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AccountType @ squareup/invest/model.proto at 12:1
 */
export const AccountType = $root.lookupEnum('squareup.invest.AccountType').values;
/**
 * **  Captures Buy or Sell activity of assets  *﹡//
 *
 * SOURCE InvestingActivity @ squareup/invest/model.proto at 19:1
 */
export const InvestingActivity = $root.lookupType('squareup.invest.InvestingActivity');
fixType(InvestingActivity);
Builder.createAndAttachToType(InvestingActivity);
/**
 * SOURCE ActivityType @ squareup/invest/model.proto at 20:4
 */
InvestingActivity.ActivityType = $root.lookupEnum('squareup.invest.InvestingActivity.ActivityType').values;
/**
 * SOURCE Status @ squareup/invest/model.proto at 26:4
 */
InvestingActivity.Status = $root.lookupEnum('squareup.invest.InvestingActivity.Status').values;
/**
 * SOURCE InvestmentAccountMetadata @ squareup/invest/model.proto at 59:1
 */
export const InvestmentAccountMetadata = $root.lookupType('squareup.invest.InvestmentAccountMetadata');
fixType(InvestmentAccountMetadata);
Builder.createAndAttachToType(InvestmentAccountMetadata);
/**
 * SOURCE AccountStatus @ squareup/invest/model.proto at 60:3
 */
InvestmentAccountMetadata.AccountStatus = $root.lookupEnum('squareup.invest.InvestmentAccountMetadata.AccountStatus').values;
/**
 * SOURCE AccountRelationship @ squareup/invest/model.proto at 76:3
 */
InvestmentAccountMetadata.AccountRelationship = $root.lookupEnum('squareup.invest.InvestmentAccountMetadata.AccountRelationship').values;
/**
 * Contains more parameters than the original banking withholding config.
 * only use for internal service messaging and internal admin
 *
 * SOURCE InvestWithholdingMetadata @ squareup/invest/model.proto at 127:1
 */
export const InvestWithholdingMetadata = $root.lookupType('squareup.invest.InvestWithholdingMetadata');
fixType(InvestWithholdingMetadata);
Builder.createAndAttachToType(InvestWithholdingMetadata);
/**
 * Ingested by CDP to track the withholding config updates for a merchant.
 *
 * SOURCE WithholdingUpdateEvent @ squareup/invest/model.proto at 144:1
 */
export const WithholdingUpdateEvent = $root.lookupType('squareup.invest.WithholdingUpdateEvent');
fixType(WithholdingUpdateEvent);
Builder.createAndAttachToType(WithholdingUpdateEvent);